export default "__VITE_ASSET__BdVcwtbq__"